import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import formImage from "../../assets/login/cp-form-pic.svg";
import toast, { Toaster } from "react-hot-toast";
import { IoEye, IoEyeOff } from "react-icons/io5";
import ForgotPassword from "./ForgotPassword";

const SignIn = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [passType, setPassType] = useState(true);

  //Initializing the react-hook form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setLoading(true);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/user/user-login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of Log-In: ", response?.data);
        setLoading(false);
        // Storing mock token and user data in localStorage
        localStorage.setItem("Ananya-Enterprize-authToken", "tokentokentoken");
        localStorage.setItem(
          "Ananya Enterprize-Users-Data",
          JSON.stringify(response?.data?.user)
        );
        toast.success(response.data.message);

        // Navigating to the dashboard
        navigate("/admin/dashboard");
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          // Server responded with a status code outside of 2xx range
          console.log("Error response:", error.response);

          if (error.response.status === 401 || error.response.status === 400) {
            toast.error(
              error.response.data.message ||
                "Invalid credentials. Please try again."
            );
          } else if (error.response.status === 404) {
            toast.error(
              error.response.data.message ||
                "User not found registered with this email"
            );
          } else {
            toast.error(
              error.response.data.message ||
                "Something went wrong. Please try again."
            );
          }
        } else if (error.request) {
          // Request was made but no response received
          console.log("Error request:", error.request);
          toast.error("No response from server. Please try again later.");
        } else {
          // Something else happened while setting up the request
          console.log("Error:", error.message);
          toast.error("An unexpected error occurred. Please try again.");
        }
      });
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gradient-to-tr from-purple-300 via-purple-600 to-purple-300 p-4 md:px-8 md:py-32 ">
      <Toaster />
      <div className="w-full rounded bg-white px-4 py-8 shadow-xl md:px-24 md:py-16 lg:w-[80%] lg:px-16 ">
        <div className="flex justify-between gap-4">
          <div className="flex flex-1 flex-col gap-4">
            {/* Heading */}
            <div className="mb-4 flex flex-col xl:mt-12">
              <h1 className="mb-2 text-4xl font-bold tracking-wide text-gray-800">
                Welcome Back !
              </h1>
              <h1 className="text-2xl font-semibold tracking-wide text-purple-600 ">
                Log into Your Dashboard
              </h1>
            </div>

            {/* Input Fields */}

            {/* Email */}
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col gap-4"
            >
              <div className="flex flex-col gap-1">
                <label
                  htmlFor="email"
                  className="text-sm font-bold tracking-wide text-gray-800"
                >
                  Email Address <span className="text-red-600">*</span>
                </label>

                <input
                  type="email"
                  placeholder="you@example.com"
                  {...register("email", { required: "Email is required" })}
                  className={`mt-1 border px-4 py-2 ${
                    errors.email ? "border-red-500" : "border-gray-300"
                  } w-full rounded-lg outline-none focus:ring-2 focus:ring-purple-500 xl:w-[80%]`}
                />

                {errors.email && (
                  <span className="text-sm text-red-500">
                    {errors.email.message}
                  </span>
                )}
              </div>

              {/* Password */}
              <div className="relative flex flex-col gap-1">
                <label
                  htmlFor="email"
                  className="flex w-full justify-between text-sm font-bold tracking-wide text-gray-800 xl:w-[80%]"
                >
                  <span>
                    Password <span className="text-red-600">*</span>
                  </span>
                  <span
                    className="cursor-pointer font-bold text-purple-600 underline hover:text-purple-800"
                    onClick={() => navigate("/auth/forgot-password")}
                  >
                    Forgot Password ?
                  </span>
                </label>

                <div className="flex items-center gap-2">
                  <input
                    type={!passType ? "text" : "password"}
                    placeholder="Enter 6 characters or more"
                    {...register("password", {
                      required: "Password is required",
                    })}
                    className={`mt-1 border px-4 py-2 ${
                      errors.password ? "border-red-500" : "border-gray-300"
                    } w-full rounded-lg outline-none focus:ring-2 focus:ring-purple-500 xl:w-[80%]`}
                  />
                  {passType ? (
                    <IoEyeOff
                      onClick={() => setPassType(false)}
                      size="20"
                      color="#c435c0"
                      className="cursor-pointer"
                    />
                  ) : (
                    <IoEye
                      onClick={() => setPassType(true)}
                      size="20"
                      color="#c435c0"
                      className="cursor-pointer"
                    />
                  )}
                </div>

                {errors.password && (
                  <span className="text-sm text-red-500">
                    {errors.password.message}
                  </span>
                )}
              </div>
              <div className="my-4 flex flex-col">
                <button
                  type="submit"
                  className="flex w-full items-center justify-center rounded bg-purple-600 px-4 py-2 text-center font-bold tracking-wide text-white hover:bg-purple-900 xl:w-[80%] "
                >
                  {loading ? <div className="loaderButton"></div> : "Log In"}
                </button>
              </div>
            </form>
          </div>

          <div className="hidden w-[60%] lg:block ">
            <img src={formImage} alt="" />
          </div>
        </div>
      </div>
      {/* <button
        onClick={login}
        className="bg-primary text-white px-6 py-3 rounded-md font-semibold shadow-lg hover:bg-hoverPrimary transition-all"
      >
        Login
      </button> */}
    </div>
  );
};

export default SignIn;
